import Footer from './Footer';
import {Question, SelectLang, FullScreen, SearchInput, Theme, Download} from './RightContent';
import {AvatarDropdown, AvatarName} from './RightContent/AvatarDropdown';
import ProTable from '@/components/ProTable';
import PageContainer from '@/components/PageContainer';
import FileNavigationBar from '@/components/FileNavigationBar';
import React from "react";

interface ModalFormProps {
    width?: number;
    title?: string;
    trigger?: React.ReactNode;
    initialValues?: any;
    onSubmit?: (values: Record<string, any>) => Promise<boolean>;
    modalProps?: Record<string, any>;
    callback?: (obj?: any) => Promise<void> | Promise<boolean> | undefined | void;
    open?: boolean;
    onCancel?: () => void;
}


export {
    AvatarDropdown, AvatarName, Footer, Question, SelectLang,
    FullScreen,
    SearchInput,
    Theme,
    ProTable,
    PageContainer,
    FileNavigationBar,
    ModalFormProps,
    Download,
};
